import { Box, Divider, Text, Button, Stack } from '@stitch-fix/mode-react';
import React from 'react';
import './styles.module.scss';
import PropTypes from 'prop-types';
import EmptyBagImage from './EmptyBagImage';
import { trackEmptyBagCtaClick } from '../ShoppingBag.tracking';

const EmptyBag = ({
  businessLine,
  navigatedFromPDP,
  navigatedFromLandingPage,
}) => {
  return (
    <Stack>
      <Box as="header">
        <Text setting="title-xlarge" align="center" mb={0.5} mt={1.5}>
          Your bag is empty
        </Text>
      </Box>
      <Box as="article" px={1.5} mb={2}>
        {navigatedFromPDP && (
          <>
            <Text setting="body-small" mb={0.75}>
              An empty bag is full of style possibilities.
            </Text>

            <Box maxWidth={20} m="auto">
              <Button
                as="a"
                onClick={() => window.history.back()}
                variant="filled-statement"
                width="fill"
              >
                Back to Shopping
              </Button>
            </Box>

            <Stack my={{ sm: 0.5, md: 1 }} maxWidth={29} mx="auto">
              <Divider variant="section">
                <Text height="short" scale="1">
                  OR
                </Text>
              </Divider>
            </Stack>
          </>
        )}

        <Text setting="body-small" mb={1}>
          Tell us about your style & fit, and we&apos;ll curate a store just for
          you.
        </Text>

        <Box maxWidth={20} m="auto" mb={{ sm: 1.5, md: 2 }}>
          <Button
            as="a"
            variant={navigatedFromPDP ? 'filled-staple' : 'filled-statement'}
            width="fill"
            href="/t/signup"
            onClick={trackEmptyBagCtaClick}
          >
            Take your style quiz
          </Button>
        </Box>
      </Box>
      <Box styleName="image-container" maxWidth={29}>
        <EmptyBagImage
          businessLine={businessLine}
          navigatedFromLandingPage={navigatedFromLandingPage}
          navigatedFromPDP={navigatedFromPDP}
        />
      </Box>
    </Stack>
  );
};

EmptyBag.propTypes = {
  businessLine: PropTypes.string,
  navigatedFromPDP: PropTypes.bool.isRequired,
  navigatedFromLandingPage: PropTypes.bool.isRequired,
};

EmptyBag.defaultProps = {
  businessLine: null,
};

export default EmptyBag;
